import React, { useState } from 'react';
import {
    Box,
    Button, 
    Tab,
    Tabs, 
    Typography,
} from '@mui/material'; 
import { useNavigate } from 'react-router-dom'; 
import ManualTable from './ManualTable';
import data from './data';

function CustomTabPanel({ children, value, index, ...other }) {
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const Organizations = () => {
    const navigate = useNavigate();
    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="h6" fontWeight="600">
                    Organizations
                </Typography>
                <Box className="d-flex gap-10 align-items-center"> 
                    <Button 
                        onClick={() => {}} 
                        sx={{ 
                            background: '#0076FE', 
                            px: '16px', 
                            borderRadius: '50px', 
                            color: '#fff', 
                            fontSize: '14px', 
                            textTransform: 'capitalize', 
                            height: '40px', 
                            border: '1px solid #E5E8EB', 
                            boxShadow: 'none',
                            '&:hover': {
                                background: '#0056b3',
                            }
                        }}
                    >
                        + Add Organizations
                    </Button>
                </Box>
            </Box>  
            {/* Tabs */}
            <Box sx={{ display: 'inline-block' }}>
                <Tabs 
                    value={value} 
                    onChange={handleChange} 
                    aria-label="basic tabs example" 
                    TabIndicatorProps={{ style: { display: 'none' } }}
                    sx={{
                        minHeight: 'auto',
                        display: 'flex',
                        gap: '15px',
                    }}
                >
                    <Tab 
                        label={`Active (${data.length})`} 
                        {...a11yProps(0)} 
                        sx={{
                            textTransform: 'none',
                            minHeight: 'auto',
                            px: 3,
                            py: 1,
                            borderRadius: '60px',
                            fontWeight: 500,
                            color: '#64748B',
                            border: '1px solid #D9D9D9',
                            background: '#FFF',
                            '&.Mui-selected': {
                                color: '#fff',
                                background: '#004DFF',
                                border: '1px solid #004DFF',
                            },
                        }} 
                    />
                    <Tab 
                        label={`Archived (0)`} 
                        {...a11yProps(1)} 
                        sx={{
                            textTransform: 'none',
                            minHeight: 'auto',
                            marginLeft: '15px',
                            px: 3,
                            py: 1,
                            borderRadius: '60px',
                            fontWeight: 500,
                            color: '#64748B',
                            border: '1px solid #D9D9D9',
                            background: '#FFF',
                            '&.Mui-selected': {
                                color: '#fff',
                                background: '#004DFF',
                                border: '1px solid #004DFF',
                            },
                        }} 
                    />
                </Tabs>
            </Box>

            {/* Active Tab */}
            <CustomTabPanel value={value} index={0}>
                <ManualTable data={data} isActiveCell={true} isArchivedCell={false} isArchivedSkeleton={false} />
            </CustomTabPanel>

            {/* Archived Tab */}
            <CustomTabPanel value={value} index={1}>
                <ManualTable data={data}  isActiveCell={false} isArchivedCell={true} isArchivedSkeleton={true}/>
            </CustomTabPanel>
        </>
    );
};

export default Organizations;